import ItemInfoRow from "./ItemInfoRow";
export default ItemInfoRow;
